import { useContext } from 'react';

import { TimeseriesYFormatterContext } from '../context/TimeseriesYFormatter.context.js';

export const useTimeseriesYFormatter = () =>
  useContext(TimeseriesYFormatterContext) ?? [];
